import React, { useEffect, useState } from 'react';
import { Loader2, ClipboardList } from 'lucide-react';
import { toast } from 'sonner';
import { OrderCard } from './OrderCard';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const AdminOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_URL}/api/orders`, { credentials: 'include' })
      .then((r) => r.json())
      .then((data) => setOrders(Array.isArray(data) ? data : []))
      .catch(() => setOrders([]))
      .finally(() => setLoading(false));
  }, []);

  const updateStatus = async (orderId, status, extra = {}) => {
    try {
      const res = await fetch(`${API_URL}/api/orders/${orderId}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ status, ...extra }),
      });
      if (!res.ok) throw new Error();
      setOrders((prev) => prev.map((o) => (o.id === orderId ? { ...o, status, ...extra } : o)));
      toast.success(`Order marked as ${status}${extra.tracking_number ? ' — tracking sent to customer' : ''}`);
    } catch {
      toast.error('Failed to update status');
    }
  };

  const refundOrder = async (orderId) => {
    try {
      const res = await fetch(`${API_URL}/api/orders/${orderId}/refund`, {
        method: 'POST',
        credentials: 'include',
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || 'Refund failed');
      setOrders((prev) => prev.map((o) => (o.id === orderId ? { ...o, status: 'refunded' } : o)));
      toast.success(`Refund of $${data.amount.toFixed(2)} issued — customer notified`);
    } catch (err) {
      toast.error(err.message || 'Failed to refund order');
    }
  };

  if (loading) return <div className="flex justify-center py-20"><Loader2 className="h-8 w-8 animate-spin text-[#7B1E2B]" /></div>;

  if (orders.length === 0) {
    return (
      <div data-testid="no-orders" className="bg-white rounded-lg shadow-md p-12 text-center text-gray-500">
        <ClipboardList className="h-12 w-12 text-gray-300 mx-auto mb-3" />
        No orders yet.
      </div>
    );
  }

  return (
    <div className="space-y-5" data-testid="admin-orders-list">
      {orders.map((order) => (
        <OrderCard key={order.id} order={order} onStatusChange={updateStatus} onRefund={refundOrder} />
      ))}
    </div>
  );
};
